import { globalTheme } from '@clds/component-theme';
import { createGlobalStyle } from '@clds/theme-helper';
import { tooltipTheme } from './theme';
// source: https://github.com/react-component/tooltip/blob/master/assets/bootstrap_white.less
const spacing = globalTheme.spacing.xxs;
export const Global = createGlobalStyle `
  .cld-tooltip.cld-tooltip-zoom-enter,
  .cld-tooltip.cld-tooltip-zoom-leave {
    display: block;
  }
  .cld-tooltip-zoom-enter,
  .cld-tooltip-zoom-appear {
    opacity: 0;
    animation-duration: ${tooltipTheme.paper.transition.duration};
    animation-fill-mode: both;
    animation-timing-function: ease-in-out;
    animation-play-state: paused;
  }
  .cld-tooltip-zoom-leave {
    animation-duration: ${tooltipTheme.paper.transition.duration};
    animation-fill-mode: both;
    animation-timing-function: ease-in-out;
    animation-play-state: paused;
  }
  .cld-tooltip-zoom-enter.cld-tooltip-zoom-enter-active,
  .cld-tooltip-zoom-appear.cld-tooltip-zoom-appear-active {
    animation-name: cldTooltipStart;
    animation-play-state: running;
  }
  .cld-tooltip-zoom-leave.cld-tooltip-zoom-leave-active {
    animation-name: cldTooltipEnd;
    animation-play-state: running;
  }
  @keyframes cldTooltipStart {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes cldTooltipEnd {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  .cld-tooltip {
    position: absolute;
    z-index: 10000;
    display: block;
    visibility: visible;
    opacity: 1;
  }
  .cld-tooltip-hidden {
    display: none;
  }
  .cld-tooltip-placement-top,
  .cld-tooltip-placement-topLeft,
  .cld-tooltip-placement-topRight {
    padding: 5px 0 ${spacing} 0;
  }
  .cld-tooltip-placement-right,
  .cld-tooltip-placement-rightTop,
  .cld-tooltip-placement-rightBottom {
    padding: 0 5px 0 ${spacing};
  }
  .cld-tooltip-placement-bottom,
  .cld-tooltip-placement-bottomLeft,
  .cld-tooltip-placement-bottomRight {
    padding: ${spacing} 0 5px 0;
  }
  .cld-tooltip-placement-left,
  .cld-tooltip-placement-leftTop,
  .cld-tooltip-placement-leftBottom {
    padding: 0 ${spacing} 0 5px;
  }
  .cld-tooltip-inner {
    min-height: 34px;
  }
  .cld-tooltip-arrow {
    display: none;
  }
`;
//# sourceMappingURL=Tooltip.styles.js.map